/**
 * Individual row component for the Admin Console, containing the data for each
 * user, and contains the buttons that open the password update modal and allow
 * the admin to view the users transactions in the portal
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import { startCase } from 'lodash';
import Button from '../ReusableComponents/Button/Button';
import TableCell from '../ReusableComponents/Table/TableCell';
import TableRow from '../ReusableComponents/Table/TableRow';
import styles from './Admin.module.css';
import ApplicationStatus from '../../Lib/Constants/vendor-application-status';
import { getApplicationStatus } from '../../Lib/Utils/FormUtils/vendor-application';
import Role from '../../Lib/Constants/roles.ts';

export function getPageLink(currentRole, targetRole, approved) {
  const specificRoleToVendorPage = {
    [Role.COMPLIANCE]: {
      [Role.VENDOR_STAFF]: 'purchase-orders',
      [Role.VENDOR]: 'factories',
    },
    [Role.SCHEDULER]: {
      [Role.VENDOR_STAFF]: 'deliveries',
      [Role.VENDOR]: 'deliveries',
    },
    DEFAULT: {
      [Role.VENDOR_STAFF]: 'requested-items',
      [Role.VENDOR_OPERATIONS]: 'purchase-orders',
      [Role.VENDOR]: 'dashboard',
      [Role.INFLUENCER]: 'influencer-payee-information',
    },
  };

  if (!approved) return 'profile';
  return (
    specificRoleToVendorPage[currentRole]?.[targetRole] ||
    specificRoleToVendorPage.DEFAULT[targetRole] ||
    'dashboard'
  );
}

class UserRow extends Component {
  constructor(props) {
    super(props);
    this.handleModal = this.handleModal.bind(this);
  }

  /**
   * Handles the opening of the modal and passes the vendor being updated up to
   * the Admin Console through the openModal function
   *
   * @param {object} ev a click event
   */
  handleModal(ev) {
    const { openModal, user } = this.props;
    openModal(ev, user);
  }

  render() {
    const { user } = this.props;
    const { id, vendor, email, last_logged_in_at, role } = user;
    const {
      company_name = null,
      is_individual = false,
      first_name = '',
      last_name = '',
      country = '',
      legal_name = '',
    } = vendor || {};
    const applicationStatus = getApplicationStatus(vendor || {});
    const approved = ApplicationStatus.APPROVED === applicationStatus;
    const page = getPageLink(user.role, role, approved);

    const vendorName = () => {
      if (is_individual) {
        if (!first_name && !last_name) return '-';
        return `${first_name} ${last_name}`;
      }
      return company_name || legal_name || '-';
    };

    return (
      <TableRow>
        <TableCell scope="row" align="left">
          {vendorName()}
        </TableCell>
        <TableCell padding="normal" align="left">
          {country ? `${country}` : '-'}
        </TableCell>
        <TableCell padding="normal" align="left">
          {startCase(applicationStatus)}
        </TableCell>
        <TableCell padding="normal" align="left">
          {is_individual ? 'Individual' : 'Company'}
        </TableCell>
        <TableCell padding="normal" align="left">
          {email}
        </TableCell>
        <TableCell padding="normal" align="left">
          {last_logged_in_at &&
            moment(last_logged_in_at).format('MM-DD-YYYY, h:mm:ss')}
        </TableCell>
        <TableCell padding="normal" align="left">
          <div className={styles.actions}>
            <Link to={`/users/${id}/${page}`} className={styles.actionsLink}>
              <Button small variant="outlined" color="primary">
                Login As
              </Button>
            </Link>
            <Button
              small
              variant="outlined"
              color="secondary"
              onClick={this.handleModal}
            >
              Manage User
            </Button>
          </div>
        </TableCell>
      </TableRow>
    );
  }
}

UserRow.propTypes = {
  user: PropTypes.shape({
    vendor_name: PropTypes.string,
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    last_logged_in_at: PropTypes.string,
    role: PropTypes.string,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
};

export default UserRow;
